export const colors = {
  brand: {
    bordo: "#4E0F26",
    bordoLight: "#6B1535",
    bordoDark: "#3A0A1C",
    blue: "#0F4C81",
    blueLight: "#1A6AAD",
    blueDark: "#0A3560",
    gold: "#D4A017",
    goldLight: "#E8B52A",
    green: "#2E6F57",
  },
  text: {
    primary: "#0F172A",
    inverse: "#FFFFFF",
    muted: "#475569",
    soft: "#64748B",
  },
  bg: {
    page: "#F7F4EF",
    surface: "#FFFFFF",
    soft: "#E8EEF5",
  },
  border: {
    light: "#D6D9DE",
    strong: "#94A3B8",
  },
  state: {
    success: "#2E6F57",
    warning: "#B7791F",
    danger: "#9F1239",
  },
};

export const site = {
  name: "Bursa Trabzonlular Derneği",
  shortName: "BTD",
  domain: "bursatrabzonlulardernegi.org",
  slogan: "Kökümüz Trabzon, Yuvamız Bursa, Yönümüz Gelecek",
  mission:
    "Bursa'daki Trabzonluları aynı çatı altında buluşturan; kültürünü yaşatan, dayanışmayı güçlendiren ve geleceğe birlikte yürüyen bir dernek.",
  founded: "2005",
  phone: "0533 815 16 61",
  email: "info@bursatrabzonlulardernegi.org",
  address: "Konak, Barış Sk. No:1/1, 16110 Nilüfer/Bursa",
};
